var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 316.941V460.223C128 465.189 129.156 470.09 131.379 474.533L145.689 503.154C151.586 514.947 168.414 514.947 174.311 503.154L188.621 474.533C190.844 470.09 192 465.189 192 460.223V316.941C181.607 318.861 170.941 320 160 320S138.393 318.861 128 316.941ZM160 0C80.471 0 16 64.471 16 144S80.471 288 160 288S304 223.529 304 144S239.529 0 160 0ZM160 80C124.719 80 96 108.719 96 144C96 152.844 88.844 160 80 160S64 152.844 64 144C64 91.062 107.062 48 160 48C168.844 48 176 55.156 176 64S168.844 80 160 80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.84a77f363dd440e1b5d33eaa29abd5ba.svg";
export { ForwardRef as ReactComponent };